module.exports = __webpack_public_path__ + "static/media/navbar-img-2.1b589b0f.jpg";